import React from 'react'
import injectSheet from 'react-jss'
import styles from './edit-dialog.styles'
import { Modal, ModalFooter, ModalHeader } from 'pobble-components/dist/modal'
import SlideForm from '../slide-form/slide-form'
import { closeEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.actions'
import { getEditSlideDialog } from '../../../pages/lesson/builder/redux/builder.selectors'
import { useDispatch, useSelector } from 'react-redux'
import { getSlide } from '../../../../stores/presentation/presentation.selectors'
import Button from 'pobble-components/dist/button'
import { updateSlide } from '../../../../stores/presentation/presentation.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const LinkSlideEditDialog = ({ classes }) => {
  const dispatch = useDispatch()
  const close = () => dispatch(closeEditSlideDialog())
  const editSlideDialog = useSelector(getEditSlideDialog)
  const slide = useSelector(state => getSlide(state, editSlideDialog.slideId))
  const modalOpened = editSlideDialog.opened && editSlideDialog.type === 'Link'

  return !slide ? null : (
    <Modal closeButton isOpen={modalOpened} requestClose={close}>
      <ModalHeader>Edit link slide</ModalHeader>
      <SlideForm
        defaultValues={{
          title: slide.title,
          url: slide.link && slide.link.site_url,
          htmlText: slide.html_text
        }}
        onSubmit={values => {
          dispatch(
            updateSlide(slide.id, 'Link', {
              title: values.title,
              link_id: values.linkId,
              text: values.text,
              html_text: values.htmlText
            })
          ).catch(errorHandler)
        }}
        footer={({ status }) => (
          <ModalFooter alignRight childrenGap>
            <Button action={close} tall simple>
              Cancel
            </Button>
            <Button pending={status === 'pending'} tall type="submit">
              Update slide
            </Button>
          </ModalFooter>
        )}
      />
    </Modal>
  )
}

export default injectSheet(styles)(LinkSlideEditDialog)
